import React from 'react'
import Modal from 'react-modal'
import Header from 'app/React/Components/Header/Header'
import Footer from 'app/React/Components/Footer/Footer'
import Main from 'app/React/Components/Main/Main'
import clx from 'classnames'
import IsNotDealerConfigurator from 'app/React/Components/misc/IsNotDealerConfigurator'
import ConfiguratorContainer from "app/React/ConfiguratorContainer";

export default function Configurator(props) {
  Modal.setAppElement('body')

  return (
    <ConfiguratorContainer {...props}>
      <>
        <div id='mg-configurator' className={clx({ 'has-no-footer': props.isDealerConfigurator ?? false })}>
          <Header/>
          <Main/>
          <IsNotDealerConfigurator>
            <Footer/>
          </IsNotDealerConfigurator>
        </div>
      </>
    </ConfiguratorContainer>
  )
}
